
import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface ToggleFieldProps {
  id: string;
  label: string;
  description?: string;
  checked?: boolean;
  disabled?: boolean;
}

export const ToggleField: React.FC<ToggleFieldProps> = ({
  id,
  label,
  description,
  checked = false,
  disabled = false
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="space-y-0.5">
        <Label htmlFor={id}>{label}</Label>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      <Switch 
        id={id} 
        checked={checked} 
        disabled={disabled}
      />
    </div>
  );
};
